@switch (reason()) {
  @case ('map') {
    <!-- There are no results in the map extent -->
    <h2 class="text-base font-semibold">No homes found in this part of the map</h2>

    <p class="mt-1 text-sm text-gray-500">
      We would be happy to contact you as soon as a home in this area is available. Would you like
      to know when one becomes available? We'd love to keep you informed!
    </p>
  }
  @case ('model') {
    <!-- There are no results with the selected model(s) -->
    <h2 class="text-base font-semibold">No homes of this model found</h2>

    <p class="mt-1 text-sm text-gray-500">
      We would be happy to contact you as soon as a home of this type is available. Would you like
      to know when one becomes available? We'd love to keep you informed!
    </p>
  }
  @case ('rep') {
    <!-- There are no resulsts with the selected rep(s) -->
    <h2 class="text-base font-semibold">No homes found by this rep</h2>

    <p class="mt-1 text-sm text-gray-500">
      We would be happy to contact you as soon as a homes by this rep are available. Would you like
      to know when one becomes available? We'd love to keep you informed!
    </p>
  }
  @default {
    <!-- No results (most likely caused by filtering) -->
    <h2 class="text-base font-semibold">What an excellent choice!</h2>

    <p class="mt-1 text-sm text-gray-500">
      We would be happy to contact you as soon as a home of this type is available. Would you like
      to know when one becomes available? We'd love to keep you informed!
    </p>
  }
}

@if (filteringService.relatedModels().length) {
  <button (click)="navToSuggestions()" class="underline pt-3">You may also like</button>
}

<app-contact-form [formType]="formType()" showComment="false" showHeader="false" />

<div class="mt-4 flex">
  <button
    type="button"
    (click)="filteringService.resetFilters()"
    class="text-sm font-medium text-primary-500 hover:text-primary-400 dark:text-primary-50 dark:hover:text-primary-100 cursor-pointer"
  >
    Or reset your filters
    <span aria-hidden="true"> &olarr;</span>
  </button>
</div>

<div #suggestionsTag></div>
